import config from "../components/config/config";

/**
 * Single source of truth for the platform flag is config.PLATFORM_MODE
 * (backend/frontend/env-driven, see Stage 0). These are just readable
 * boolean helpers on top of it — do not duplicate the flag itself.
 */
export const isDTS = () => config.PLATFORM_MODE === "DTS";
export const isPPH = () => !isDTS();
